import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getUserTypes,
  deleteUserType,
  changeStatusUserType,
} from "../../../../api/userType";
import {
  Button,
  Tooltip,
  Switch,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";

function getData(userTypes) {
  let data = [];
  for (let i = 0; i < userTypes.length; ++i) {
    const elem = {};
    console.log(userTypes);
    elem.titulo = userTypes[i].titulo;
    elem.precio = userTypes[i].precio;
    elem.id = userTypes[i]._id;
    elem.active = userTypes[i].active;
    elem.asociado = userTypes[i].asociado || false;
    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  active: false,
};

export default function UserTypesPage() {
  const [data, setData] = useState([]);
  const [userTypeId, setUserTypeId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-usertype/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserTypeId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserTypeId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "titulo", text: "Titulo", sort: true },
    {
      dataField: "precio",
      text: "Precio Semestral",
      formatter: (cell) => (
        <span>
          {cell?.semestral?.toLocaleString("es-ES", {
            style: "currency",
            currency: "EUR",
          })}
        </span>
      ),
    },
    {
      dataField: "precio",
      text: "Precio Anual",
      formatter: (cell) => (
        <span>
          {cell?.anual?.toLocaleString("es-ES", {
            style: "currency",
            currency: "EUR",
          })}
        </span>
      ),
    },
    {
      dataField: "asociado",
      text: "Asociado",
      sort: true,
      formatter: (cell) => (
        <span
          style={{
            color: cell ? "#4CAF50" : "#999",
            fontWeight: cell ? "bold" : "normal",
          }}
        >
          {cell ? "Sí" : "No"}
        </span>
      ),
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getUserTypes()
      .then((res) => {
        if (res.status === 200) {
          let users = res.data;
          for (let user of users) {
            if (Array.isArray(user.historico) && user.historico.length > 0) {
              const latest = user.historico.reduce((a, b) =>
                new Date(a.date) > new Date(b.date) ? a : b
              );

              user.precio = latest.price;
            } else {
              user.precio = 0;
            }
          }
          setData(users);
          setFilteredData(users);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get userTypes." });
      });
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}
            >
              {/* Switches a la izquierda */}
              <div
                className="d-flex align-items-center flex-wrap"
                style={{ gap: "30px" }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={
                    filterOptions.active
                      ? "Solo activos"
                      : "Todos (activos/inactivos)"
                  }
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px",
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a",
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista Tipos de Usuarios">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-usertype")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          <Table data={getData(filteredData)} columns={columns} />

          <ConfirmDialog
            title={`Are you sure you want to ${
              userTypeId?.active ? "disable" : "enable"
            } this user type?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusUserType(userTypeId.id, !userTypeId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${userTypeId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User type ${
                        userTypeId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      userTypeId?.active ? "disable" : "enable"
                    } user type.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this user type?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteUserType(userTypeId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "UserType removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove userType.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
